import { useQuery } from "@tanstack/react-query"
import {
  notificationApiCalls,
  notificationQueryKeys,
} from "../api/notificationApi"
import { UNREAD_COUNT_POLL_INTERVAL_MS } from "../constants"

/**
 * The ONLY poller in the notification system. Returns
 * `{ count, actionRequiredCount }`; hidden tabs stop polling.
 */
export const useUnreadCount = () => {
  return useQuery({
    queryKey: notificationQueryKeys.unreadCount,
    queryFn: notificationApiCalls.getUnreadCount,
    refetchInterval: UNREAD_COUNT_POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}
